export enum MasterDataEntityTypeEnum {
  Place = 0,
  Country,
  Port,
  Terminal,
  Depot,
  Vessel,
  Comment,
  StepTemplate,
  UnitOfMeasurement,
  ContainerIsoCode,
  HsCode,
  Incoterm,
  ContactPersonType,
  ImoClassification,
  SealNumberType,
  PartyType,
  PackageType,
  ActivityCode,
  Step,
  Company,
  CompanyAddress,
  OcrSetting,
  OutgoingTaxCode,
  IncomingTaxCode,
}
